/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateIoeRequest
 */
export interface UpdateIoeRequest {
    /**
     * Free-text comment explaining why this finding is suppressed. Only used when `is_disabled` is `true`.
     */
    disabledComment?: string | null;
    /**
     * Reason category for disabling this finding. Only used when `is_disabled` is `true`.
     */
    disabledReason?: string | null;
    /**
     * UUID of the user disabling this finding. Set automatically by the server; can be omitted.
     */
    disabledUserUid?: string | null;
    /**
     * `true` to suppress this finding; `false` to re-enable it.
     */
    isDisabled?: boolean | null;
    /**
     * Optional expiry of the exception. Must be in the future; afterwards the finding counts again. Omit or `null` for an exception without expiry.
     */
    disabledUntil?: Date | null;
}

/**
 * Check if a given object implements the UpdateIoeRequest interface.
 */
export function instanceOfUpdateIoeRequest(value: object): value is UpdateIoeRequest {
    return true;
}

export function UpdateIoeRequestFromJSON(json: any): UpdateIoeRequest {
    return UpdateIoeRequestFromJSONTyped(json, false);
}

export function UpdateIoeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIoeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'disabledComment': json['disabled_comment'] === undefined ? undefined : json['disabled_comment'] === null ? null : json['disabled_comment'],
        'disabledReason': json['disabled_reason'] === undefined ? undefined : json['disabled_reason'] === null ? null : json['disabled_reason'],
        'disabledUserUid': json['disabled_user_uid'] === undefined ? undefined : json['disabled_user_uid'] === null ? null : json['disabled_user_uid'],
        'isDisabled': json['is_disabled'] === undefined ? undefined : json['is_disabled'] === null ? null : json['is_disabled'],
        'disabledUntil': json['disabled_until'] === undefined ? undefined : json['disabled_until'] === null ? null : (parseDateTime(json['disabled_until'])),
    };
}

export function UpdateIoeRequestToJSON(json: any): UpdateIoeRequest {
    return UpdateIoeRequestToJSONTyped(json, false);
}

export function UpdateIoeRequestToJSONTyped(value?: UpdateIoeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disabled_comment': value['disabledComment'],
        'disabled_reason': value['disabledReason'],
        'disabled_user_uid': value['disabledUserUid'],
        'is_disabled': value['isDisabled'],
        'disabled_until': value['disabledUntil'] == null ? value['disabledUntil'] : serializeDateTime(value['disabledUntil']),
    };
}

